import { Action } from '@ngrx/store';

export const DELETE_REQUEST = '[Application] Delete Request';
export const DELETE_SUCCESS = '[Application] Delete Success';
export const DELETE_ERROR =   '[Application] Delete Error';

/**
 * Request to delete application. Payload contains application id.
 */
export class DeleteRequestAction implements Action {
    readonly type = DELETE_REQUEST;

    constructor(public payload: string) {}
}

/**
 * Application has been deleted.
 * Payload contains appId.
 */
export class DeleteSuccessAction implements Action {
    readonly type = DELETE_SUCCESS;

    /**
     * Payload is deleted appId.
     */
    constructor(public payload: string) {}
}

/**
 * Error when deleting application.
 */
export class DeleteErrorAction implements Action {
    readonly type = DELETE_ERROR;

    constructor(public payload: any) { }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = DeleteRequestAction
    | DeleteSuccessAction
    | DeleteErrorAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/actions/application-delete.actions.ts